import React, { useState, useEffect, useContext } from 'react';
import Auxiliary from '../../util/Auxiliary';
import { Link  } from 'react-router-dom';
import { message } from 'antd';
import axios from '../../util/Api';
import { ParamsContext } from '../Context/ParamsContext';
import Table from '../../components/Table/Basic';
import { useSelector } from 'react-redux';

const Vendor = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(null);
  const { authUser } = useSelector(({ auth }) => auth);

  const params = useContext(ParamsContext);

  const columns = [
    {
      title: 'Nama Perusahaan',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      filter: true
    },
    {
      title: 'Jenis Perusahaaan',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Kode Perusahaan',
      dataIndex: 'code',
      key: 'code',
      filter: true
    },
    {
      title: 'Email',
      key: 'email',
      dataIndex: 'email',
      filter: true,
    },
    {
      title: 'Telepon/WA',
      key: 'phone',
      dataIndex: 'phone',
    },
    {
      title: '',
      key: 'action',
      render: record => (
        <div className="gx-text-right">
          <Link to={`/vendor/update?id=${record.id}`} className="gx-mr-1 ant-btn ant-btn-secondary ant-btn-sm">
            Edit
          </Link>
          <Link to={`/vendor/detail?id=${record.id}`} className="ant-btn ant-btn-secondary ant-btn-sm">
            Detail
          </Link>
        </div>
      )
    },
  ];

  useEffect(() => {
    fetchVendorList();
  }, [params]);

  const fetchVendorList = () => {
    setLoading(true);
    const url = `/vendor/list`;
    axios.get(url, { params: params }).then(({ data }) => {
      setData(data.vendors);
      setTotalData(data.total);
      setLoading(false);
    }).catch(err => {
      message.error(`Error: ${err}`);
    });
  }

  return (
    <Auxiliary>
      <h1 className="title gx-mb-4">Perusahaan</h1>
      <Link to="/vendor/create" className="ant-btn ant-btn-primary">Tambah Perusahaan Baru</Link>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        total={totalData}
        pathname="/vendor"
      />
    </Auxiliary>
  );
}

export default Vendor;